/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-debugger */

import { create } from 'zustand'

import { ConnectStepErrorMapping } from '../constants/Options'

const defaultProps = {
  connectStep: 'connection_to_signal',
  errorType: null,
  isInited: false,
  connected: false,
  deviceStreamReady: false,
  messageCode: 0,
}

export const useKvmStatusStore = create((set, get) => ({
  ...JSON.parse(JSON.stringify(defaultProps)),
  setInited: (isInited) => {
    set({ isInited })
  },
  setConnected: () => {
    set({ connected: true })
  },
  setVideoLost: () => {
    set({ connected: false })
  },
  connectedTimeout: () => {
    const currentConnectStep = get().connectStep
    const connected = get().connected
    if (!connected) {
      console.log(
        'The message returns longer than expected, and the connection state is set to disconnected.',
      )
      const errorType = ConnectStepErrorMapping[currentConnectStep] || 'connection_lost'
      set({ errorType: errorType, connected: false })
    }
  },
  setMessageCode: (code) => {
    const currentConnectStep = get().connectStep
    if (currentConnectStep === 'establish_stream') {
      if (code === 4) {
        set({ connected: true, deviceStreamReady: true })
      } else {
        if (get().deviceStreamReady) {
          set({ errorType: 'no_stream', connected: false, deviceStreamReady: false })
        }
      }
    }
  },
  setConnectStatusByPeerConnection: (status) => {
    const currentConnectStep = get().connectStep
    const deviceStreamReady = get().deviceStreamReady
    const connected = get().connected
    console.log('Peer connection status change', {
      status,
      currentConnectStep,
      deviceStreamReady,
      connected,
    })
    if (status === 'connected') {
      set({
        connectStep: 'establish_stream',
        errorType: null,
        connected: deviceStreamReady ? true : false,
      })
    } else if (status === 'disconnected') {
      if (currentConnectStep === 'establish_stream') {
        set({ errorType: 'no_stream', connected: false })
      } else {
        set({ errorType: 'no_candidate', connected: false })
      }
    } else if (status === 'failed') {
      set({ errorType: 'connection_lost', connected: false })
    }
  },
  setConnectionStatus: ({ step, error }) => {
    const currentConnectStep = get().connectStep
    set({ connectStep: step || currentConnectStep, errorType: error || null })
  },
  setConnectStep: (step) => {
    set({ connectStep: step })
  },
  setErrorType: (error) => {
    set({ errorType: error })
  },
}))
